const SET_ADVERTISEMENT = 'advertisements/SET_ADVERTISEMENT';

export default {
  SET_ADVERTISEMENT,
};



// WEBPACK FOOTER //
// ./src/app/advertisements/store/mutation-types.js